import { Button } from '@cannect/new-components/atoms'
import { subscriptionsCopy } from '../copy'

export const LoadError = ({
  onRetry,
  message = subscriptionsCopy.loadError.list
}: {
  onRetry: () => void
  message?: string
}) => (
  <div
    role="alert"
    className="flex w-full flex-col items-start gap-3 rounded-xl border border-solid border-neutral-200 bg-white p-6">
    <p className="text-base text-neutral-800">{message}</p>
    <Button variant="outline_light" size="md" onClick={onRetry}>
      {subscriptionsCopy.loadError.retry}
    </Button>
  </div>
)
